import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resWorkshop {
  message: string,
  result: {
    createtime: Date,
  }
  success: boolean,
}

interface resGetAllWorkshop {
  message: string,
  result: [{
    COUNT_REGIS: number;
    WORKSHOP_COACH: string,
    WORKSHOP_COACH_PIC: string,
    WORKSHOP_DATE: string,
    WORKSHOP_DETAIL: string,
    WORKSHOP_ID: string,
    WORKSHOP_NAME: string,
    WORKSHOP_PHONENUM: string,
    WORKSHOP_PLACE: string,
    WORKSHOP_PRICE: number;
    WORKSHOP_QTY_LEARNERS: number;
  }];
  success: boolean,
}

interface resGetWorkshopById {
  message: string,
  result: [{
    CREATE_DATE: Date,
    UPDATE_DATE: Date,
    WORKSHOP_DOC: [{
      DOC_ID: number;
      DOC_NAME: string,
      DOC_URL: string,
    }];
    WORKSHOP_PIC: string
    WORKSHOP_PICNAME: string,
    COUNT_REGIS: number;
    WORKSHOP_COACH: string,
    WORKSHOP_COACH_PIC: string,
    WORKSHOP_COACH_PICNAME: string,
    WORKSHOP_DATE: string,
    WORKSHOP_DETAIL: string,
    WORKSHOP_ID: string,
    WORKSHOP_NAME: string,
    WORKSHOP_PHONENUM: string,
    WORKSHOP_PLACE: string,
    WORKSHOP_PRICE: number;
    WORKSHOP_QTY_LEARNERS: number;
    STATUS_PUBLIC: boolean,
  }];
  success: boolean,
}

interface resDownloadWorkshop {
  message: string,
  result: {
    LIST: [{
      ID: number;
      REGISTER_AFFILIATE: string,
      REGISTER_EMAIL: string,
      REGISTER_NAME: string,
      REGISTER_TYPE: string,
    }],
    WORKSHOP_NAME: string,
  };
  success: boolean,
}

interface resAllConsult {
  message: string,
  result: [{
    USER_ID: string,
    USERNAME: string
  }];
  success: boolean,
}

interface resGetCalendaConsultByUser {
  message: string,
  result: [{
    CONSULT_ID: string,
    CONSULT_NAME: string,
    CONSULT_DATE_START: Date,
    CONSULT_DATE_END: Date,
    CONSULT_TYPE: string,
    CONSULT_MAX: number,
    CONSULT_OBJECT: string,
    CREATE_DATE: Date,
    USER_ID: string,
    UPDATE_DATE: Date,
    CONSULT_STATUS: string
  }];
  success: boolean,
}

interface resGetDetailConsultByDate {
  message: string,
  result: [{
    CONSULT_DATE: Date,
    CONSULT_STATUS: string,
    CONSULT_DETAIL: [{
      CONSULT_ID: string,
      CONSULT_NAME: string,
      CONSULT_DATE_START: Date,
      CONSULT_DATE_END: Date,
      CONSULT_TYPE: string,
      CONSULT_MAX: number,
      CONSULT_OBJECT: string,
      CREATE_DATE: Date,
      USER_ID: string,
      UPDATE_DATE: Date,
      CREATE_BY: string,
      UPDATE_BY: string,
      CONSULT_TIME: string
    }]
  }];
  success: boolean,
}

interface resCreateConsult {
  message: string,
  result: [{
    createtime: string
  }];
  success: boolean,
}

interface resExportCalendaConsultById {
  message: string,
  result: [
    {
      CONSULT_CATEGORY: string,
      CONSULT_COUNT_REGISTER: number,
      CONSULT_DATE_END: Date,
      CONSULT_DATE_START: Date,
      CONSULT_ID: string,
      CONSULT_JOIN_TYPE: string,
      CONSULT_MAX: number,
      CONSULT_SOLUTION: string,
      CONSULT_STATUS: string,
      CONSULT_TOTAL_PRICE: number,
      CONSULT_TYPE: string,
      CONSULT_UNIT_PRICE: number,
      CREATE_DATE: Date,
      ID: number,
      MORE_DETAIL: string,
      UPDATE_DATE: Date,
      USER_ID: string,
      USERNAME: string,
      CUSTOMER_NAME: string
    }
  ];
  success: boolean,
}

interface resExportAllCalendaConsultByDate {
  message: string,
  result: [
    {
      CONSULT_COUNT_REGISTER: number,
      CONSULT_DATE_END: Date,
      CONSULT_DATE_START: Date,
      CONSULT_ID: string,
      CONSULT_MAX: number,
      CONSULT_TYPE: string,
      USERNAME: string,
      register: [
        {
          CONSULT_CATEGORY: string,
          CONSULT_COUNT_REGISTER: number,
          CONSULT_ID: string,
          CONSULT_JOIN_TYPE: string,
          CONSULT_SOLUTION: string,
          CONSULT_STATUS: string,
          CONSULT_TOTAL_PRICE: number,
          CONSULT_TYPE: string,
          CONSULT_UNIT_PRICE: number,
          CREATE_DATE: Date,
          ID: number,
          MORE_DETAIL: string,
          UPDATE_DATE: Date,
          USER_ID: string,
          CUSTOMER_NAME: string
        }
      ]
    }
  ];
  success: boolean,
}



@Injectable({
  providedIn: 'root'
})
export class ActivityManagementService {
  token: string;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  createWorkshop(body) {
    let formData = new FormData;
    const headers = new HttpHeaders({ Authorization: this.token })

    // // console.log(body);

    for (let i = 0; i < body.workshopDoc.fileList?.length; i++) {
      formData.append('WORKSHOP_DOC', body.workshopDoc.fileList[i].originFileObj);
    }

    formData.append('WORKSHOP_NAME', body.workshopName);
    formData.append('WORKSHOP_PLACE', body.workshopPlace);
    formData.append('WORKSHOP_DATE', JSON.stringify(body.workshopDateTime));
    formData.append('WORKSHOP_COACH', body.workshopCoach);
    formData.append('WORKSHOP_COACH_PIC', body.workshopCoachPic);
    formData.append('WORKSHOP_PRICE', body.workshopPrice);
    formData.append('WORKSHOP_PHONENUM', body.workshopPhoneNO);
    formData.append('WORKSHOP_DETAIL', body.workshopDetail);
    formData.append('WORKSHOP_PIC', body.workshopCover);
    formData.append('WORKSHOP_QTY_LEARNERS', body.workshopQuantity);
    formData.append('WORKSHOP_COACH_ASSIT', JSON.stringify(body.workshopCoachAssit.listOfValue));
    formData.append('JOIN_TYPE', body.joinType);
    formData.append('STATUS_PUBLIC', body.statusPublic);
    formData.append('ACCOUNTING_ID', body.accountId);

    if (body.centerId) {
      if (body.centerId.length > 0) {
        for (let i = 0; i < body.centerId.length; i++) {
          const el = body.centerId[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<resWorkshop>(environment.URL + '/manage_admin/createWorkShop', formData, { headers: headers });
  }

  getAllWorkshop() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetAllWorkshop>(environment.URL + '/manage_admin/getAllWorkShop', { headers: headers });
  }

  getWorkshopById(id) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetWorkshopById>(environment.URL + '/workshop/getDetailWorkShopById?WORKSHOP_ID=' + id, { headers: headers });
  }

  editWorkshop(body, id, docDelete) {
    let formData = new FormData;
    const headers = new HttpHeaders({ Authorization: this.token })
    // // console.log(body)

    if (body.workshopDoc !== '') {
      for (let i = 0; i < body.workshopDoc.fileList?.length; i++) {
        if (body.workshopDoc.fileList[i].originFileObj) {
          formData.append('WORKSHOP_DOC', body.workshopDoc.fileList[i].originFileObj);
        }
      }
    }

    if (docDelete.length > 0) {
      formData.append('DELETE_DOCS', JSON.stringify(docDelete));
    } else {
      formData.append('DELETE_DOCS', JSON.stringify(docDelete));
    }

    if (body.workshopCoachPic !== '') {
      formData.append('WORKSHOP_COACH_PIC', body.workshopCoachPic);
    }
    if (body.workshopCover !== '') {
      formData.append('WORKSHOP_PIC', body.workshopCover);
    }

    formData.append('WORKSHOP_ID', id);
    formData.append('WORKSHOP_NAME', body.workshopName);
    formData.append('WORKSHOP_PLACE', body.workshopPlace);
    formData.append('WORKSHOP_DATE', JSON.stringify(body.workshopDateTime));
    formData.append('WORKSHOP_COACH', body.workshopCoach);
    formData.append('WORKSHOP_PRICE', body.workshopPrice);
    formData.append('WORKSHOP_PHONENUM', body.workshopPhoneNO);
    formData.append('WORKSHOP_DETAIL', body.workshopDetail);
    formData.append('WORKSHOP_QTY_LEARNERS', body.workshopQuantity);
    formData.append('WORKSHOP_COACH_ASSIT', JSON.stringify(body.workshopCoachAssit.listOfValue));
    formData.append('JOIN_TYPE', body.joinType);
    formData.append('STATUS_PUBLIC', body.statusPublic);
    formData.append('ACCOUNTING_ID', body.accountId);

    if (body.centerId) {
      if (body.centerId.length > 0) {
        for (let i = 0; i < body.centerId.length; i++) {
          const el = body.centerId[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<resWorkshop>(environment.URL + '/manage_admin/editWorkShopById', formData, { headers: headers });
  }

  deleteWorkshopById(id) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resWorkshop>(environment.URL + '/manage_admin/deleteWorkShopById', { WORKSHOP_ID: id }, { headers: headers });
  }

  downloadWorkshop(id) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resDownloadWorkshop>(environment.URL + '/workshop/downloadWorkShop', { WORKSHOP_ID: id }, { headers: headers });
  }

  getAllConsult() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resAllConsult>(environment.URL + '/manage_admin/getAllConsult', { headers: headers });
  }

  getCalendaConsultByUser(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetCalendaConsultByUser>(environment.URL + '/manage_admin/getCalendaConsultByUser', body, { headers: headers });
  }

  getDetailConsultByDate(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDetailConsultByDate>(environment.URL + '/manage_admin/getDetailConsultByDate', body, { headers: headers });
  }

  createConsult(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resCreateConsult>(environment.URL + '/manage_admin/createConsult', body, { headers: headers });
  }

  exportCalendaConsultById(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resExportCalendaConsultById>(environment.URL + '/manage_admin/exportCalendaConsultById', body, { headers: headers });
  }

  exportAllCalendaConsultByDate(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resExportAllCalendaConsultByDate>(environment.URL + '/manage_admin/exportAllCalendaConsultByDate', body, { headers: headers });
  }
}
